module.exports = __webpack_public_path__ + "img/矩形1777.d72a526d.png";